import { render, staticRenderFns } from "./Anli.vue?vue&type=template&id=05e56311"
import script from "./Anli.vue?vue&type=script&lang=js"
export * from "./Anli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports